import React from "react";
import { Link } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import { Cookie, ExternalLink } from "lucide-react";

const platformHubs = [
  ["OnlyFans VIP", "/crm/onlyfans-vip"],
  ["OnlyFans Free", "/crm/onlyfans-free"],
  ["JustForFans", "/crm/jff"],
  ["Faphouse", "/crm/faphouse"],
  ["TheBlowers", "/crm/theblowers"],
  ["RawFuckClub", "/crm/rfc"],
  ["Intimaly", "/crm/intimaly"],
];

export default function ExtensionCookies() {
  return (
    <AppLayout title="Platform Cookie Sessions" overline="CHROME EXTENSION">
      <div className="max-w-4xl space-y-5">
        <div className="flex items-start gap-3 border-y border-zinc-800 py-4">
          <Cookie size={19} className="mt-0.5 shrink-0 text-emerald-400" />
          <p className="text-sm text-zinc-300">
            This legacy page no longer reads or displays cookie values. Existing stored settings are untouched. Cookie-session controls and masked metadata are available in each platform hub.
          </p>
        </div>
        <nav aria-label="Platform cookie session hubs" className="grid grid-cols-1 gap-x-6 sm:grid-cols-2">
          {platformHubs.map(([name, href]) => (
            <Link key={href} to={href} className="flex min-h-11 items-center justify-between gap-3 border-b border-zinc-800 py-3 text-sm text-zinc-200 hover:text-emerald-300">
              {name}<ExternalLink size={14} />
            </Link>
          ))}
        </nav>
      </div>
    </AppLayout>
  );
}
